<template>
  <b-col md="5" lg="4">
    <div style="padding-1" id="summary">
      <h5 class="my-4 text-center">Inquiry Summary</h5>
      <dl class="p-4">
        <dt>Subtotal</dt>
        <dd>
          
          <span v-if="$store.state.corporateCode">
            <del>AED {{this.formatProduct($store.getters.getOrderSubTotalOld)}}</del>
          </span>

          AED {{this.formatProduct($store.getters.getOrderSubTotal)}}
        </dd>
        <dt v-if="!$store.state.corporateCode">Shipping</dt>
        <dd
          v-if="!$store.state.corporateCode"
        >AED {{this.formatProduct($store.getters.getOrderShipping)}}</dd>
        <dt>VAT (5%)</dt>
        <dd>AED {{this.formatProduct($store.getters.getVat)}}</dd>
        <dt>Total</dt>
        <dd>
          AED
          <span>{{this.formatProduct($store.getters.getOrderTotal)}}</span>
        </dd>
      </dl>

      <div class="px-4 text-center">
        <button
          class="btn btn-primary"
          id="checkout-btn"
          v-if="!page"
          v-on:click="$router.push({name: 'Checkout'})"
        >Place Inquiry</button>
        <div v-else>
          <voucher-code></voucher-code>
          <button
            class="btn btn-primary"
            id="checkout-btn"
            v-on:click="$emit('place-order')"
          >Place Inquiry</button>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import voucherCode from "./VoucherCode";

export default {
  name: "OrderSummary",
  props: ["page"],
  components: {
    "voucher-code": voucherCode,
  },
  mounted() {
    this.$store.dispatch("updateShippingCost");
  },
};
</script>

<style scoped>
#summary {
  border: 1px solid #959595;
  padding: 20px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
}

li {
  display: inline-block;
}

dl {
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

dt {
  float: left;
  width: 60%;
  padding: 0;
  margin: 0;
  font-weight: 600;
  margin-bottom: 10px;
}

dd {
  float: left;
  width: 40%;
  padding: 0;
  margin: 0;
  font-weight: 600;
  margin-bottom: 25px;
}

#checkout-btn,
#paypal-btn {
  background-color: #41b2d2;
  border: none;
  border-radius: 10px;
  width: 80%;
  padding: 10px;
  text-transform: uppercase;
}

#paypal-btn {
  background-color: white;
  border: 1px solid #41b2d2;
  border-radius: 10px;
  width: 80%;
  padding: 10px;
  color: #41b2d2;
}
</style>
